import clientApiManager from '../clientApiManager'
import {isMobileDeviceOrScreen} from '../../common/agent/agentUtils';

const FOUR_FOUR_DESKTOP_BANNER = '886'
const FOUR_FOUR_MOBILE_BANNER = '887'

export function bannerService(storefrontApiClient = clientApiManager) {
  const type = isMobileDeviceOrScreen() ? FOUR_FOUR_MOBILE_BANNER : FOUR_FOUR_DESKTOP_BANNER;
  return storefrontApiClient.get(`/banners?types=${type}`);
}



// WEBPACK FOOTER //
// ./src/service/banner/bannerService.js